import { useMemo, useContext } from 'react';
import { abTestDataContext } from 'app/containers/contexts/abTest.context';

export const useGetCashbackTestsValues = () => {
    const {
        // @ts-ignore
        cashback_new_users: cashbackOldTestValue,
        cashback_new_users_v2: cashbackNewTestValue,
    } = useContext(abTestDataContext);

    const isCashbackTestGroup = useMemo(
        () => (
            cashbackOldTestValue === 'with_cashback'
            || cashbackNewTestValue === 'with_cashback'
        ),
        [cashbackOldTestValue, cashbackNewTestValue],
    );

    return [isCashbackTestGroup];
};
